import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const EXPORT_REQUEST = 'DEPLOYMENT/EXPORT_REQUEST' as const;

export interface IExportRequestPayload {
  destinationTopics: string[];
}

export interface IExportRequestAction {
  type: typeof EXPORT_REQUEST;
  payload: IExportRequestPayload;
}

export const exportRequestPayloadSchema = objectSchemaOf<IExportRequestPayload>(
  {
    destinationTopics: Joi.array().items(Joi.string()).required(),
  }
);

export const exportRequestActionSchema = objectSchemaOf<IExportRequestAction>({
  type: Joi.string().valid(EXPORT_REQUEST).required(),
  payload: exportRequestPayloadSchema.required(),
});

export const exportRequest = actionCreator({
  type: EXPORT_REQUEST,
  schema: exportRequestActionSchema,
  // NOTE: This action can be sent to any feature/topic
});
